import React from "react";

export const MediaRenderer = ({ src, className = "" }) => {
  if (!src) return null;

  // Extract file extension
  const extension = src.split(".").pop().toLowerCase();

  // Common image and video extensions
  const imageTypes = ["jpg", "jpeg", "png", "gif", "webp", "svg", "ico"];
  const videoTypes = ["mp4", "webm", "ogg", "mov"];

  if (imageTypes.includes(extension)) {
    return <img src={src} alt="" className={className} />;
  }

  if (videoTypes.includes(extension)) {
    return (
      <video src={src} className={className} loop autoPlay muted>
        Your browser does not support the video tag.
      </video>
    );
  }

  // If extension is unrecognized
  return <p>Unsupported media type: {extension}</p>;
};
